// extracted by mini-css-extract-plugin
module.exports = {"login_conatiner":"login_conatiner___DST1M","avatar":"avatar___Mj9MM","examine":"examine___39wL4"};